'use strict';

var callDateSet = require('../../common/internal/callDateSet');

function setMonth(d, val) {
  callDateSet(d, 'Month', val);
}

module.exports = setMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/internal/setMonth.js
// module id = 120
// module chunks = 0